/* eslint-disable jsx-a11y/img-redundant-alt */
import { Row, Table, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { pupSelector, spamSelector } from "../../../services/selector/index.";
import { IconLock, IconNext, IconPre, IconSuccess } from "../../../assets/icon";
import "../../../assets/style/table/survey.scss";
import { useEffect, useState } from "react";
import { useMemo } from "react";
import { setOpenPUDelete } from "../../../services/slice/PopUpSlice";
import TranslateText from "../TranslateText";
import { setPageProduct } from "../../../services/slice/StoreSlice";
import { useTranslation } from "react-i18next";
import {
  deleteSurvey,
  setOpenEditSurvey,
} from "../../../services/slice/SurveySlice";
import ModalDelete from "../Modal/delete/ModalDelete";
import moment from "moment";
import { getLogFileSpam } from "../../../services/slice/SpamSlice";

const TblListReport = () => {
  const dispatch = useDispatch();
  const spamState = useSelector(spamSelector);
  const statePup = useSelector(pupSelector);
  const { dataDelete } = statePup;
  //   const { config, data, total, callBackRequest } = surveyState;
  const [page, setPage] = useState(0);
  const [isDeleteTbl, setIsDeleteTbl] = useState(false);
  const [dataTBL, setDataTBL] = useState([]);
  //   useEffect(() => {
  //     dispatch(getDataSurvey(config));
  //   }, [config.search, config.status, config.typeSurvey, dispatch]);
  //     const data =[{

  //     }]
  useEffect(() => {
    setDataTBL(spamState.listReport.data);
  }, [spamState?.listReport?.data]);
  const total = 1;
  const dataSource = useMemo(() => {
    const result = dataTBL?.map((item, index) => {
      return {
        ...item,
        object: item.typeSurvey === 1 ? "Toàn bộ KH" : "CCS",

        STT: total > 10 && page >= 2 ? (page - 1) * 10 + index + 1 : index + 1,
        key: item.guid,
      };
    });
    return result;
  }, [dataTBL, page]);
  const rowClassName = (record) => {
    return record.typeSurvey === 2 ? "marked-row" : "";
  };
  //   useEffect(() => {
  //     if (callBackRequest) {
  //       dispatch(
  //         getDataSurvey({
  //           search: "",
  //           status: 0,
  //           typeSurvey: 0,
  //           option: {
  //             limit: 10,
  //             offset: 1,
  //             order: "asc",
  //           },
  //         })
  //       );
  //     }
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //   }, [callBackRequest]);

  const handleShowEditModal = (value) => {
    dispatch(setOpenEditSurvey({ isOpen: true, id: value.id }));
  };
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(
        `selectedRowKeys: ${selectedRowKeys}`,
        "selectedRows: ",
        selectedRows
      );
    },
    getCheckboxProps: (record) => ({
      disabled: false, // Không disable checkbox cho bất kỳ hàng nào
    }),
  };

  const columns = [
    {
      title: "STT",
      dataIndex: "STT",
      key: "STT",
      className: "centerCell",
      width: 70,
    },

    {
      title: <TranslateText text="SĐT bị phản ánh" />,
      dataIndex: "phoneNumberScam",
      key: "phoneNumberScam",
      className: "title pointer centerCell",
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: <TranslateText text="Số lần bị phản ánh" />,
      dataIndex: "count",
      key: "count",
      className: "title pointer centerCell",
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: <TranslateText text="Phân loại" />,
      dataIndex: "phanLoai",
      key: "phanLoai",
      className: "title pointer centerCell",
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: (
        <div className="statusProduct">
          <p className="textStatus">
            <TranslateText text="Thời gian cuối gửi phản ánh" />
          </p>
        </div>
      ),
      dataIndex: "thoiGianGuiPhanAnh",
      key: "thoiGianGuiPhanAnh",
      className: "centerCell",
      render: (text, record) => (
        <span>
          <span>{moment(text).format("DD/MM/YYYY HH:MM")}</span>
        </span>
      ),
    },
    {
      title: <TranslateText text="Trạng thái" />,
      dataIndex: "trangThai",
      key: "trangThai",
      className: "title pointer centerCell",
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: <TranslateText text="Chức năng" />,
      key: "action",
      dataIndex: "action",
      className: "centerCell m10",
      render: (text, record) => {
        return (
          <div
            className="centerCell flex justify-center w-full "
            style={{ minWidth: "120px" }}
          >
            <span
              className="pointer iconTbl"
              onClick={() => handleShowEditModal(record)}
              style={{ marginRight: "3rem" }}
            >
              <Tooltip title="Duyệt">
                <IconSuccess
                  width={20}
                  height={20}
                  fill="rgba(4, 125, 231, 1)"
                />
              </Tooltip>
            </span>
            <span
              className="pointer iconTbl "
              onClick={() => dispatch(getLogFileSpam(record.guid))}
            >
              <Tooltip title="Xem log">
                <IconLock />
              </Tooltip>
            </span>
          </div>
        );
      },
    },
  ];
  // const tableLoading = {
  //   spinning: storeState.isLoading, // isLoading là biến boolean để xác định xem có đang loading hay không
  //   indicator: <IconSpin className="iconSpin" />,
  // };

  const handleDelete = () => {
    dispatch(deleteSurvey(dataDelete.id));
    setIsDeleteTbl(false);
    dispatch(setOpenPUDelete({ stateOpen: false, id: "", content: "" }));
  };
  return (
    <>
      {dataDelete.isOpenPUDelete && isDeleteTbl ? (
        <ModalDelete
          handleDelete={handleDelete}
          textDisable="Bạn có đồng ý xóa cuộc khảo sát này"
          title="Xóa cuộc khảo sát"
          width={680}
        />
      ) : null}
      <Row style={{ width: "100%" }}>
        <Table
          rowClassName={rowClassName}
          //   loading={tableLoading}
          rowSelection={{
            ...rowSelection,
          }}
          className="wrapperTblSurvey"
          style={{ width: "100%", marginTop: "2.6rem" }}
          columns={columns}
          dataSource={dataSource}
          pagination={
            total > 10
              ? {
                  onChange: (value) => {
                    setPage(value);
                    dispatch(setPageProduct(value));
                  },
                  total,
                  pageSize: 10,
                  //   current: config.option.offset,
                  prevIcon: <IconPre />,
                  nextIcon: <IconNext />,
                  showSizeChanger: false,
                }
              : false
          }
        />
      </Row>
    </>
  );
};

export default TblListReport;
